import INotification from "../../model/interface/ui/INotification";
import ITimeTracker from "../../model/interface/extension/ITimeTracker";
import {STREAM_EVENTS_SAVE, STREAM_EVENTS_UPDATE} from "../constants/StreamEvents";

export interface IStreamEventsState {
    notifications: INotification[],
    timeTracker?: ITimeTracker
    contentTypes?: {[key: string]: string};
    workloadReports?: {[key: string]: number};
    setup?: string
    version?: string
    initialLoading: boolean
    forceReload?: boolean
    menuRecordsCounts?: {[key: string]: number}
}

type IAction = {
    type: string,
    [x: string]: any
} & Partial<IStreamEventsState>;

const initState: IStreamEventsState = {
    notifications: [],
    timeTracker: undefined,
    initialLoading: true
}

const notifications = (state = initState, action: IAction) => {
    switch (action.type) {
        case STREAM_EVENTS_SAVE: {
            return {
                ...state,
                notifications: action.hasOwnProperty('notifications') ? action.notifications : state.notifications,
                timeTracker: action.hasOwnProperty('timeTracker') ? action.timeTracker : state.timeTracker,
                contentTypes: action.hasOwnProperty('contentTypes') ? action.contentTypes : state.contentTypes,
                workloadReports: action.hasOwnProperty('workloadReports') ? action.workloadReports : state.workloadReports,
                setup: action.hasOwnProperty('setup') ? action.setup : state.setup,
                version: action.hasOwnProperty('version') ? action.version : state.version,
                forceReload: action.hasOwnProperty('forceReload') ? action.forceReload : false,
                menuRecordsCounts: action.hasOwnProperty('menuRecordsCounts') ? action.menuRecordsCounts : state.menuRecordsCounts,
                initialLoading: false
            }
        }
        case STREAM_EVENTS_UPDATE: {
            return {
                ...state,
                ...action
            }
        }
        default:
            return state
    }
}

export default notifications